import { forwardRef } from "react";
import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "../lib/cn";

export interface DescriptionListProps
  extends HTMLAttributes<HTMLDListElement> {}

export interface DescriptionItemProps extends HTMLAttributes<HTMLDivElement> {
  label: ReactNode;
  value: ReactNode;
}

/** Compact label/value data with a bounded label column and wrapping values. */
export const DescriptionList = forwardRef<
  HTMLDListElement,
  DescriptionListProps
>(({ className, ...props }, ref) => (
  <dl ref={ref} className={cn("flex flex-col gap-2", className)} {...props} />
));
DescriptionList.displayName = "DescriptionList";

export const DescriptionItem = forwardRef<HTMLDivElement, DescriptionItemProps>(
  ({ label, value, className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn("flex min-w-0 items-baseline gap-4", className)}
      {...props}
    >
      <dt className="w-1/3 min-w-20 max-w-40 shrink-0 text-content-secondary">
        {label}
      </dt>
      <dd className="m-0 min-w-0 flex-1 break-words font-medium text-content-primary">
        {value}
      </dd>
    </div>
  ),
);
DescriptionItem.displayName = "DescriptionItem";
